import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowGridViewContext } from 'store/Workspace/selectors';
import { toogleGridView } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { Wrapper, GridViewIcon, CustomButton } from './styled';

// eslint-disable-next-line import/prefer-default-export
export const GridViewButton = () => {
  const showGridView = useSelector(selectShowGridViewContext);
  const dispatch = useDispatch();

  return !showGridView && (
    <Wrapper>
      <CustomButton startIcon={ <GridViewIcon /> } onClick={ () => dispatch(toogleGridView(!showGridView)) }>Grid View</CustomButton>
    </Wrapper>
  );
};
